<template>
  <div id="app" class="VB_App" @contextmenu.prevent.stop>
    <ViewmedicaBrochureToolbar />
    <vue-progress-bar class="VB_Progress" />
    <router-view />
  </div>
</template>

<script>
import ViewmedicaBrochureToolbar from "@/components/ViewmedicaBrochureToolbar.vue";

export default {
  name: "ViewmedicaBrochureApp",

  components: {
    ViewmedicaBrochureToolbar
  }
};
</script>

<style lang="scss">
#app {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;

  @media print {
    height: auto;
    overflow: visible;
  }
}

body,
html {
  margin: 0;
  padding: 0;
  background: rgb(83, 86, 89);

  @media print {
    html,
    body {
      width: 8.5in !important;
      height: 11in !important;
      background: white;
    }

    @page {
      size: 8.5in 11in;
      margin-top: 0.25in;
      margin-left: 0.5in;
      margin-right: 0.5in;
      margin-bottom: 0.25in;
    }
  }

  &:lang(ar) {
    h3,
    p {
      direction: rtl;
    }
  }
}

* {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  user-select: none !important;
}

.VB_Progress {
  top: 50px !important;
}

.VB_Error {
  position: absolute;
  width: 70vw;
  max-width: 800px;
  text-align: center;
  margin: auto;
  top: 50px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f1f1f1;
  font-size: 1.5em;
  font-weight: 300;
}

@page {
  margin: 0in;
  padding: 0in;
}
</style>
